import lazyScreen from '../utils/lazyScreen';
const PMProjects = lazyScreen(() => import('../pages/pm/PMProjects/index.js'), 'pages/pm/PMProjects/index.js');
const PMProject = lazyScreen(() => import('../pages/pm/PMProject/index.js'), 'pages/pm/PMProject/index.js');
const PMWorkspaces = lazyScreen(() => import('../pages/pm/PMWorkspaces/index.js'), 'pages/pm/PMWorkspaces/index.js');
const PMWorkspace = lazyScreen(() => import('../pages/pm/PMWorkspace/index.js'), 'pages/pm/PMWorkspace/index.js');
const PMResources = lazyScreen(() => import('../pages/pm/PMResources/index.js'), 'pages/pm/PMResources/index.js');
const PMResource = lazyScreen(() => import('../pages/pm/PMResource/index.js'), 'pages/pm/PMResource/index.js');
const PMProjectTemplates = lazyScreen(() => import('../pages/pm/PMProjectTemplates/index.js'), 'pages/pm/PMProjectTemplates/index.js');
const PMProjectTemplate = lazyScreen(() => import('../pages/pm/PMProjectTemplate/index.js'), 'pages/pm/PMProjectTemplate/index.js');

export default [
    {
        path: '/pm/PMWorkspaces',
        component: PMWorkspaces
    },
    {
        path: '/pm/PMWorkspace/:code',
        component: PMWorkspace
    },
    {
        path: '/pm/PMProjects',
        component: PMProjects
    },
    {
        path: '/pm/PMProject/:code',
        component: PMProject
    },
    {
        path: '/pm/PMResources',
        component: PMResources
    },
    {
        path: '/pm/PMResource/:code',
        component: PMResource
    },
    {
        path: '/pm/PMProjectTemplates',
        component: PMProjectTemplates
    },
    {
        path: '/pm/PMProjectTemplate/:code',
        component: PMProjectTemplate
    }
];
